import {
  createStylesParams,
  StyleParamType,
  wixColorParam,
} from '@wix/tpa-settings';
import {
  StyleType,
  CssColor,
  CssVariable,
  wixVariable,
} from '@wix/editor-platform-ooi-metadata-resolver';

type IStylesParams = {
  titleDividerColor: StyleParamType.Color;
  titleDividerWidth: StyleParamType.Number;
  itemsDividerColor: StyleParamType.Color;
  itemsDividerWidth: StyleParamType.Number;
};

export const dividerStylesParams = createStylesParams<IStylesParams>({
  titleDividerColor: {
    type: StyleParamType.Color,
    getDefaultValue: wixColorParam('color-5', 0.3),
    metadata: {
      type: StyleType.borderBottomColor,
      defaultValue: {
        type: 'static',
        preset: CssColor.WstSystemLine1Color,
        opacity: 0.3,
      },
    },
  },
  titleDividerWidth: {
    type: StyleParamType.Number,
    getDefaultValue: () => 1,
    metadata: {
      type: StyleType.width,
      defaultValue: wixVariable(CssVariable.WstSystemLine1Width),
    },
  },
  itemsDividerColor: {
    type: StyleParamType.Color,
    getDefaultValue: wixColorParam('color-5', 0.3),
    metadata: {
      type: StyleType.borderBottomColor,
      defaultValue: {
        type: 'static',
        preset: CssColor.WstSystemLine1Color,
        opacity: 0.3,
      },
    },
  },
  itemsDividerWidth: {
    type: StyleParamType.Number,
    getDefaultValue: () => 1,
    metadata: {
      type: StyleType.width,
      defaultValue: wixVariable(CssVariable.WstSystemLine1Width),
    },
  },
});
